import { doc, setDoc, increment } from "firebase/firestore";
import { db, auth } from "../../../firebase/firebase.js";
import {
  fetchTodayData,
  updateTodayData,
  getTodayString,
} from "../../../utils/todayData.js";

export const updateActivity = async (node, incrementValue) => {
  const uid = auth.currentUser.uid;
  const todayData = (await fetchTodayData(uid)) || {};
  const activities = todayData.activities || {};
  activities[node.id] = {
    title: node.title,
    timestamp: new Date().toISOString(),
    points: activities[node.id]?.points
      ? activities[node.id].points + incrementValue
      : incrementValue,
  };
  await updateTodayData(uid, {
    ...todayData,
    date: todayData.date || getTodayString(),
    activities,
  });
};
